import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IState, Item } from "../../../../interfaces/interfaces";
import SectionItems from "../../../../components/SectionItems/SectionItems";
import API from "../../../../api/api";
import { addSeries } from "../../../../store/actions/ItemActions";

const Series = () => {
  const { series } = useSelector((state: IState) => state.item);
  const [loading, setLoading] = useState(series.length === 0);
  const dispatch = useDispatch();

  useEffect(() => {
    API.getSeries().then((res) => {
      setTimeout(() => {
        dispatch(addSeries(res as Item[]));
        setLoading(false);
      }, Math.random() * 1500 + 500);
    });
  }, [dispatch]);
  return (
    <div className="w-100">
      <SectionItems
        items={series}
        title={"Tv Series"}
        isTrending={false}
        loading={loading}
      />
    </div>
  );
};

export default Series;
